import { useState } from "react";
import type { FormEvent } from "react";
import { Link } from "react-router-dom";
import { api, ApiError } from "../api";

/**
 * POST /api/auth/forgot-password always returns {ok: true} (no user
 * enumeration) — so this screen always shows the same success message
 * regardless of whether the email exists, and never surfaces a
 * per-field/API error for that reason. A genuine network/validation
 * failure (bad request, server down) still shows an error.
 */
export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await api.post<{ ok: boolean }>("/api/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "could not submit request");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="card login-card">
        <h1>Forgot password</h1>
        {done ? (
          <div className="modal-body">
            <p>
              If the account exists, a reset link has been sent. You can also ask the
              administrator for a reset link.
            </p>
            <div className="muted">
              <Link to="/login">Back to sign in</Link>
            </div>
          </div>
        ) : (
          <form className="modal-body" onSubmit={onSubmit}>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            {error && <div className="error-text">{error}</div>}
            <button className="primary" type="submit" disabled={busy}>
              {busy ? "Sending..." : "Send reset link"}
            </button>
            <div className="muted">
              <Link to="/login">Back to sign in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
